import React, { Component } from "react";
import PropTypes from "prop-types";
import { getSupportedTransform } from "shared/util/Prefixes";

import { SECTION_SIZING } from "apps/discovery/util/consts";
import NavButton from "./ImportantQuestions/NavButton";
import Question from "./ImportantQuestions/Question";
import "./ImportantQuestions.scss";

class ImportantQuestions extends Component {
	constructor(props) {
		super(props);

		this.state = {
			index: props.currentPage || 0,
			transformProperty: getSupportedTransform(),
		};
	}

	_handlePreviousClick = () => {
		const { data, changeImportantQuestion } = this.props;

		if (this.state.index === 0 || !(data.questions && data.questions.length)) {
			return;
		}

		const index = this.state.index - 1;
		this.setState({ index });
		this._getNewMatches(index);
		changeImportantQuestion(index);
	}

	_handleNextClick = () => {
		const { data, changeImportantQuestion } = this.props;
		let count;

		if (data && data.questions) {
			count = data.questions.length;
		} else {
			return;
		}

		if (this.state.index === count) {
			return;
		}

		const index = this.state.index + 1;
		this.setState({ index });
		this._getNewMatches(index);
		changeImportantQuestion(index);
	}

	_getNewMatches = (index) => {
		const { data, getQuestionMatches } = this.props;
		const question = data.questions[index];

		if (!question || !question.id) {
			return;
		}

		getQuestionMatches(question.id);
	}

	render() {
		const { title, data } = this.props;
		const { index, transformProperty } = this.state;

		let questions;
		let width;
		let offset;
		const innerStyles = {};
		const hasQuestions = data && data.questions && data.questions.length;

		if (hasQuestions) {
			questions = data.questions;
			const sizes = SECTION_SIZING.importantQuestionsHeader;

			width = sizes.width * questions.length + sizes.gutter * (questions.length - 1);
			offset = (sizes.width + sizes.gutter) * -1 * index;

			innerStyles.width = width;
			innerStyles[transformProperty] = `translateX(${offset}px)`;
		}

		return (
			<div className="discovery-section-title">
				<span className="discovery-section-title-text">
					{title}
				</span>
				{hasQuestions &&
					<span>
						<div className="discovery-section-title-nav">
							<NavButton
								previous
								disabled={index === 0}
								onClick={this._handlePreviousClick}
							/>

							<span className="discovery-section-title-nav-text">
								{index + 1}/{questions.length}
							</span>

							<NavButton
								next
								disabled={index + 1 === questions.length}
								onClick={this._handleNextClick}
							/>
						</div>

						<div className="important-questions-header-wrapper">
							<div
								className="important-questions-header-wrapper-inner"
								style={innerStyles}
							>
								{questions.map((question) =>
									(<Question
										key={question.id}
										category={question.category}
										text={question.text}
										answer={question.answer}
									/>)
								)}
							</div>
						</div>
					</span>
				}
				{!questions &&
					<div className="important-questions-header-wrapper">
						<Question />
					</div>
				}
			</div>
		);
	}
}

ImportantQuestions.propTypes = {
	getQuestionMatches: PropTypes.func.isRequired,
	changeImportantQuestion: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
	data: PropTypes.object,
	currentPage: PropTypes.number,
};

export default ImportantQuestions;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/headers/ImportantQuestions.jsx